import { Routes } from '@angular/router';
import { LanguageGuard } from '@pyg-services/language/language.guard';
import { inject } from '@angular/core';
import { LanguageService } from '@pyg-services/language/language.service';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: () => {
      const langService = inject(LanguageService);
      return langService.getInitLang();
    },
    pathMatch: 'full',
  },
  {
    path: ':lang',
    canActivate: [LanguageGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pyg-components/main-page/main-page.component').then(
            (m) => m.MainPageComponent,
          ),
      },
      {
        path: 'blog',
        loadComponent: () =>
          import('@pyg-components/blog/blog.component').then(
            (m) => m.BlogComponent,
          ),
      },
      {
        path: 'blog/:article',
        loadComponent: () =>
          import('@pyg-components/blog/article/article.component').then(
            (m) => m.ArticleComponent,
          ),
      },
      {
        path: 'futureoftelco',
        loadComponent: () =>
          import(
            '@pyg-components/future-of-telco/future-of-telco.component'
          ).then((m) => m.FutureOfTelcoComponent),
      },
      {
        path: 'pygmalios-for-frontline-teams',
        loadComponent: () =>
          import('@pyg-components/pygmalios-x/pygmalios-x.component').then(
            (m) => m.PygmaliosXComponent,
          ),
      },
      { path: 'pygmalios-x', redirectTo: 'pygmalios-for-frontline-teams' },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import(
            '@pyg-components/privacy-policy/privacy-policy.component'
          ).then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'virtual-queue',
        loadComponent: () =>
          import('@pyg-components/virtual-queue/virtual-queue.component').then(
            (m) => m.VirtualQueueComponent,
          ),
      },
      {
        path: 'museums',
        loadComponent: () =>
          import('@pyg-components/museums/museums.component').then(
            (m) => m.MuseumsComponent,
          ),
      },
      {
        path: 'customer-journey-analytics-and-service-monitoring-with-tdi',
        loadComponent: () =>
          import(
            '@pyg-components/tdi-landing-page/tdi-landing-page.component'
          ).then((m) => m.TdiLandingPageComponent),
      },
      {
        path: 'tdi',
        redirectTo:
          'customer-journey-analytics-and-service-monitoring-with-tdi',
      },
      {
        path: 'ai-theft-protection',
        loadComponent: () =>
          import('@pyg-components/shopguard/shopguard.component').then(
            (m) => m.ShopguardComponent,
          ),
      },
      { path: 'shopguard', redirectTo: 'ai-theft-protection' },
      {
        path: 'in-store-analytics',
        loadComponent: () =>
          import('@pyg-components/products/products.component').then(
            (m) => m.ProductsComponent,
          ),
      },
      { path: 'products', redirectTo: 'in-store-analytics' },
      {
        path: 'contact_us',
        loadComponent: () =>
          import('@pyg-components/demo-form/demo-form.component').then(
            (m) => m.DemoFormComponent,
          ),
      },
      { path: 'contact', redirectTo: 'contact_us' },
      { path: 'getdemo', redirectTo: 'contact_us' },
      { path: '**', redirectTo: '' },
    ],
  },
  // { path: '**', redirectTo: ':lang', pathMatch: 'full' },
];
